import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import moment from 'moment';
import i18n from '../../i18next';

const ResendOrdersDatePickers = props => {

    const { containerStyles } = styles;

    return (
        <div style={containerStyles}>
            <FormGroup>
                <Label>{i18n.t('screens:systemControlContainer.startDate')}: </Label>
                <Input
                    type='datetime-local' name='startFrom'
                    value={props.state.startFrom}
                    onChange={props.setDate}
                />
            </FormGroup>

            <FormGroup style={{ marginLeft: 10 }}>
                <Label>{i18n.t('screens:systemControlContainer.endDate')}: </Label>
                <Input
                    type='datetime-local' name='endTo'
                    value={props.state.endTo}
                    min={props.state.startFrom}
                    onChange={props.setDate} />
            </FormGroup>
        </div>
    );
}

export default ResendOrdersDatePickers;

const styles = {
    containerStyles: {
        display: 'flex',
        flexDirection: 'row'
    }
}


// WEBPACK FOOTER //
// ./src/components/systemControl/ResendOrdersDatePickers.js